<template>
    <div class="step-counter">
        <span
            v-for="num in totalSteps"
            class="dot"
            :class="{ active: num === currentStep }"></span>
    </div>
</template>

<script>
    export default {
        props: ['totalSteps', 'currentStep']
    }
</script>

<style lang="scss" scoped>
    .step-counter {
      text-align: center;
    }
    .dot {
        display: inline-block;
        background-color: #D8D8D8;
        height: 8px;
        width: 8px;
        margin-right: 22px;
        border-radius: 50%;
        &.active {
          background-color: #000;
        }
    }
    .dot:last-child {
        margin-right: 0;
    }
</style>
